module.exports = __webpack_public_path__ + "static/media/contact-text.d5bf0dcc.svg";